import { anyOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { McpTokenRevocation, StartMcpTokenRevocationResult } from "./types";

export const isMcpTokenRevocation = objectOf<McpTokenRevocation>({
  operation_id: string,
  status: (value: unknown): value is McpTokenRevocation["status"] =>
    value === "pending" || value === "running" || value === "completed" || value === "failed",
  processed_token_count: number,
  failure_code: anyOf(string, (value: unknown): value is null => value === null),
});

export const isStartMcpTokenRevocationResult = (value: unknown): value is StartMcpTokenRevocationResult =>
  isMcpTokenRevocation(value) && "status_url" in value && typeof value.status_url === "string";
